module.exports = __webpack_public_path__ + "static/media/HK.6e0b86d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/HK.svg
// module id = 269
// module chunks = 0